import type { RunType } from '@/api/runs';

/** Retired types stay in the catalogue (AN12); the list hides them until staff ask. */
export const visibleRunTypes = (types: RunType[], showInactive: boolean) => (showInactive ? types : types.filter((x) => x.is_active));
